module.exports = __webpack_public_path__ + "static/media/nifl-background.2f8663d7.jpg";